// interface IFormInputDateProps {
//     label: string;
//     id: string;
//     value?: string | undefined;
//     required?: boolean | undefined;
//     onChange: (id: string, value: string) => void;
//     error?: string | undefined;
//   }
  
//   function FormInputDate({
//     label,
//     id,
//     value,
//     required,
//     onChange,
//     error,
//   }: IFormInputDateProps) {
//     return (
//       <div>
//         <label htmlFor={id} className="form-label">
//           {label}
//           {required && <>*</>}
//         </label>
//         <input
//           type="date"
//           name={id}
//           id={id}
//           value={value}
//           className="form-input"
//           required={required}
//           onChange={(e) => onChange(id, e.target.value)}
//         />
//         {error && <div className="form-error">{error}</div>}
//       </div>
//     );
//   }
  
//   export default FormInputDate;
  interface IFormInputDateProps {
  label: string;
  id: string;
  value?: string | undefined;
  required?: boolean | undefined;
  onChange: (id: string, value: string) => void;
  error?: string | undefined;
  yearOnly?: boolean | undefined;
}

function FormInputDate({
  label,
  id,
  value,
  required,
  onChange,
  error,
  yearOnly,
}: IFormInputDateProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = yearOnly ? e.target.value : e.target.value;
    onChange(id, newValue);
  };

  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <>*</>}
      </label>
      <input
        type={yearOnly ? "number" : "date"}
        name={id}
        id={id}
        value={yearOnly ? (value ? value.split('-')[0] : '') : value || ''}
        className="form-input"
        required={required}
        min={yearOnly ? "1900" : undefined}
        max={yearOnly ? "2100" : undefined}
        onChange={handleChange}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInputDate;